import * as React from 'react';

interface Props {
    header: string;
    content: JSX.Element;
    isAdmin: boolean;
}

class MyAccountUserTile extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="my-account-tile user">
                {!this.props.isAdmin && <h3 className="my-account-tile-hello">Hello there,</h3>}
                <h2 className="my-account-tile-header">{this.props.header}</h2>
                {this.props.content}
            </div>
        );
    }
}

export default MyAccountUserTile;



// WEBPACK FOOTER //
// ./src/view/MyAccountUserTile.tsx